import { baseApi } from '../../app/baseApi';
import { apiTags } from '../../app/store/apiTags';

const apiPrefix = 'me';
export const meApi = baseApi.injectEndpoints({
    reducerPath: 'loadApi',
    endpoints: (builder) => ({
        changePassword: builder.mutation({
            query: (body) => ({
                url: `${apiPrefix}/changepassword`,
                method: "POST",
                body
            }),
            invalidatesTags: [apiTags.ME]
        }),
        //TODO one API
        getTenantName: builder.query({
            query: () => `${apiPrefix}/tenant/name`,
        }),
        getClaimClientId: builder.query({
            query: () => `${apiPrefix}/claims/clientId`,
        }),
        getClaimClientAccountId: builder.query({
            query: () => `${apiPrefix}/claims/clientAccountId`,
        }),
        getHasAccessToAllClients: builder.query({
            query: () => `${apiPrefix}/hasAccessToAllClients`,
        }),
        getIsVendor: builder.query({
            query: () => `${apiPrefix}/isVendor`,
        }),
        getCurrentTenantConfig: builder.query({
            query: () => `${apiPrefix}/config`,
            providesTags: [apiTags.TENANTS],
        }),
    }),
});


export const { useChangePasswordMutation, useGetTenantNameQuery, useGetClaimClientIdQuery, useGetClaimClientAccountIdQuery, useGetHasAccessToAllClientsQuery, useGetCurrentTenantConfigQuery, useGetIsVendorQuery } = meApi;
